import { APP_PATH } from 'modules/app/constants'
import { getObjectUtil } from 'packages/src'

const hasWebpSupportAppSelect = state => {
  return getObjectUtil(state, APP_PATH.HAS_WEBP_SUPPORT)
}

export default hasWebpSupportAppSelect
